module.exports = __webpack_public_path__ + "assets/img/icon9-menu.c4d61a38.svg";